import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.css'

import { auth } from './firebase'
import App from './App'
import router from './router'
import { store } from './store'

import AlertCmp from './components/Shared/Alert.vue'
import Loader from './components/Shared/Loader.vue'
import CompletedJobView from './components/CompletedJobViewComponent.vue'
import UserView from './components/Admin/User.vue'
import CustomerView from './components/Admin/Customer.vue'
import SupplierView from './components/Admin/Supplier.vue'
import ProductView from './components/Admin/Product.vue'
import DeviceView from './components/Admin/Device.vue'
import VehicleView from './components/Admin/Vehicle.vue'
import SitesView from './components/Sites.vue'
import NewVehicleDialog from './components/Shared/NewVehicleDialog.vue'
import MultiVehicleDialog from './components/Shared/MultiVehicleDialog.vue'
import BulkAddVehicleDialog from './components/Shared/BulkAddVehicleDialog.vue'
import BulkImportExportDialog from './components/Shared/BulkImportExportDialog.vue'
import BulkUpdateJobsDialog from './components/Shared/BulkUpdateJobsDialog.vue'
import MergeJobsDialog from './components/Shared/MergeJobsDialog.vue'
import SiteEditDialog from './components/Shared/SiteEditDialog.vue'
import ContactEditDialog from './components/Shared/ContactEditDialog.vue'
import Testing from './components/Testing.vue'
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
import CalendarView from 'vue-simple-calendar'
import DayView from './components/DayView'
require('vue-simple-calendar/dist/static/css/default.css')
require('./assets/css/materialdesignicons.min.css')
Vue.use(Viewer)

Vue.use(Vuetify, {
  theme: {
    primary: '#4BBBBD',
    secondary: '#091C48',
    accent: '#45CAFF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107'
  }
})

Vue.component('app-alert', AlertCmp)
Vue.component('special-loader', Loader)
Vue.component('completed-view', CompletedJobView)
Vue.component('user-view', UserView)
Vue.component('customer-view', CustomerView)
Vue.component('supplier-view', SupplierView)
Vue.component('product-view', ProductView)
Vue.component('device-view', DeviceView)
Vue.component('vehicle-view', VehicleView)
Vue.component('sites-view', SitesView)
Vue.component('vue-simple-calendar', CalendarView)
Vue.component('calendar-day-view', DayView)
Vue.component('new-vehicle-dialog', NewVehicleDialog)
Vue.component('multi-vehicle-dialog', MultiVehicleDialog)
Vue.component('bulk-add-vehicle-dialog', BulkAddVehicleDialog)
Vue.component('bulk-import-export-dialog', BulkImportExportDialog)
Vue.component('bulk-update-jobs-dialog', BulkUpdateJobsDialog)
Vue.component('site-edit-dialog', SiteEditDialog)
Vue.component('contact-edit-dialog', ContactEditDialog)
Vue.component('merge-jobs-dialog', MergeJobsDialog)
Vue.component('testing', Testing)
Vue.config.productionTip = false

Vue.filter('uppercase', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.toUpperCase()
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App),
  store,
  created () {
    auth.onAuthStateChanged((user) => {
      if (user) {
        this.$store.dispatch('autoSignIn', user)
        this.$store.dispatch('fetchUserData', user)
      }
    })
    navigator.serviceWorker.addEventListener('message', function (event) {
      console.log('Client 1 Received Message: ' + event.data)
    })
  }
})




// WEBPACK FOOTER //
// ./src/main.js